import React, {Suspense} from 'react';
import Loading from "../../components/common/Loading";
import ServicePage from "../../components/sections/ServicePage";
import {metaByRoute} from "../../constants/meta";
import Meta from "../../components/common/Helmet";

const ErpSolutions = () => {
  const erpMeta = metaByRoute['/services/erp-solutions'];
  return (
    <div>
      <Suspense fallback={<Loading />}>
        <Meta
          title={erpMeta.title}
          description={erpMeta.description}
          canonical={erpMeta.canonical}
          keywords={erpMeta.keywords}
          ogTitle={erpMeta.title}
          ogDescription={erpMeta.description}
        />
        <ServicePage serviceKey={"desktop"}/>
      </Suspense>
    </div>
  );
};

export default ErpSolutions;
